angular.module("leanlaw").controller("AllocationModalController", ["$scope", "$timeout", "user", "close", "ModalService", "leanLawApi", "userService", "$q", function ($scope, $timeout, user, close, ModalService, leanLawApi, userService, $q) {
  $scope.isSaving = false;
  $scope.matter = matter;
  $scope.isBehindModal = false;
  $scope.save = function () {
    $scope.isSaving = true;
    doSave().then(result => {
      if (!result) return $scope.isSaving = false;
      ;

      // Remove isNew tags so the user can't edit names again
      $scope.rates.other.forEach(rate => {
        rate.isNew = false;
      });
      $scope.user.rates = $scope.rates;

      // Wait for close animation to complete (something about UX)
      $timeout(() => {
        close($scope.rates);
      }, 300);
    }, err => {
      $scope.isSaving = false;
      console.error(err);
    });
  };
  $scope.reject = function () {
    close(false);
  };

  // Close button action can be assigned to a specific response
  $scope.handleCloseButton = function () {
    close(false);
  };
}]);